import './App.css';
import { WordsearchSolver } from './components/read-and-solve';

function App() {
  return (
    <div className="App">
      <WordsearchSolver />
    </div>
  );
}

export default App;
